import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet
} from '@angular/router';

import { AnalyticsService } from '@gruposaltaedu/liv-analytics';

import { AuthSessionService } from '@app/core/services/auth-session.service';

import { AppSplashComponent } from './core/layouts/app-splash';

export declare const APP_KEY: string;

@Component({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-root',
  imports: [AppSplashComponent, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  host: {
    '(document:click)': 'onDocumentClick($event)'
  }
})
export class AppComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly authSession = inject(AuthSessionService);
  protected readonly livAnalytics = inject(AnalyticsService);
  protected readonly loading = signal<boolean>(false);

  constructor(private readonly router: Router) {
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((e) => {
        // Antes o loading dependia de `resolve`; o init passou para guards
        // (`authInitGuard`). Na primeira navegação `router.navigated` ainda é
        // false — mostramos o splash até a navegação terminar (guards + lazy + etc.).
        if (e instanceof NavigationStart && !this.router.navigated) {
          this.loading.set(true);
        }

        if (
          e instanceof NavigationEnd ||
          e instanceof NavigationCancel ||
          e instanceof NavigationError
        ) {
          this.loading.set(false);
        }
      });
  }

  onDocumentClick(event: Event): void {
    if (!this.authSession.snapshot.accessToken) {
      return;
    }

    this.livAnalytics.track(event);
  }
}
